import { IconProps } from '..';

export default function IconPencil({
  width = 24,
  height = 24,
  color = '#fff'
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="react-icons/bi/BiPencil">
        <path
          id="Vector"
          d="M3.99989 20.9997C4.0796 21.0093 4.16018 21.0093 4.23989 20.9997L8.23989 19.9997C8.41734 19.9575 8.57987 19.8676 8.70989 19.7397L20.9999 7.40966C21.3724 7.03493 21.5815 6.52803 21.5815 5.99966C21.5815 5.47129 21.3724 4.96438 20.9999 4.58966L19.4199 2.99966C19.2341 2.81371 19.0136 2.66619 18.7708 2.56554C18.528 2.46489 18.2677 2.41309 18.0049 2.41309C17.7421 2.41309 17.4818 2.46489 17.239 2.56554C16.9962 2.66619 16.7756 2.81371 16.5899 2.99966L4.29989 15.2897C4.17068 15.4203 4.07764 15.5822 4.02989 15.7597L3.02989 19.7597C2.99395 19.889 2.98444 20.0244 3.00192 20.1575C3.0194 20.2906 3.06352 20.4189 3.13165 20.5346C3.19978 20.6504 3.29052 20.7512 3.39846 20.8311C3.50639 20.911 3.62931 20.9683 3.75989 20.9997C3.8396 21.0093 3.92018 21.0093 3.99989 20.9997ZM17.9999 4.40966L19.5899 5.99966L17.9999 7.58966L16.4199 5.99966L17.9999 4.40966ZM5.90989 16.5097L14.9999 7.40966L16.5899 8.99966L7.48989 18.0997L5.37989 18.6197L5.90989 16.5097Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
